import { styled } from "@mui/material/styles";

export const DashboardStyled = styled("div")(({ theme }) => ({
  flexDirection: "column",
  display: "flex",
  alignItems: "center",
  height: "inherit",
  overflow: "hidden",

  "& .border": {
    border: 'solid 1px'
  },

  "& .footer": {
    padding: "10px 5px",
  },

  "& .profile": {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',

    "& .content": {
      height: "inherit",
      padding: "0 5px",
      overflow: 'auto'
    },

    "& .birth-date": {
      // display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'space-between',

      "& .text__birth_date": {
        width: "100%",
      }
    },

    "& .title": {
      fontWeight: "bold",
      fontSize: "15px",
    },

    "& .MuiFormControl-root": {
      marginTop: "15px"
    },

    "& .row": {
      marginTop: "15px",
    },

    "& .birth-date.row": {
      marginTop: "5px",
    }
  },

  "& .setting": {
    overflow: 'auto',
    // height: "inherit",

    "& .icon": {
      border: "5px solid black",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    "& .icon-button": {
      marginBottom: '10px'
    },
    "& .title": {
      color: "black",
      fontWeight: "bold",
      fontSize: "15px",
      // background: "#e6e6e6",
      width: "100%",
      padding: "5px 5px",
      marginTop: "10px",
    },
    "& .temperature-area": {
      display: "inline-flex",
      width: "100%",
      // overflow: 'auto',
      padding: '5px 0',

      // "& .item": {
      //   marginBottom: '5px'
      // },

      "& button": {
        width: "115px",
        height: "100px",
        outline: "none",
        border: "none",
        marginLeft: "10px",
        marginRight: "10px",
        borderRadius: "10px",
      },
    },
    "& .active": {
      color: "#fff",
      backgroundColor: "#737e87",
      boxShadow: "inset 6px 6px 12px #626b73,inset -6px -6px 12px #84919b",
      "& .icon-button": {
        "& img": {
          filter: 'brightness(0) invert(1)'
        }
      }
    },
    "& .inactive": {
      backgroundColor: "#e9edf0",
      boxShadow: "2px 2px 5px #c6c9cc,-2px -2px 5px #ffffff",
    },
  },

  "& .block-tab": {
    backgroundColor: '#EE602C',
    boxShadow: "rgba(0, 0, 0, 0.35) 0px -50px 36px -28px inset",
    width:"100%",
    zIndex: 999,
    "& .tab": {
      marginTop: "10px", 
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',

      "& .pprs": {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        paddingRight: '0px !important',
      },

      "& .pprs-child": {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',

        "& >div": {
          width: '50%'
        }
      },

      "& .colleague-finder": {
        padding: '12px !important',
        borderLeft: 'none'
      },

      "& .normal": {
        display: 'block',
        justifyContent: 'start',
        background: '#EE602C',
        width: "50%",
        padding: "4px",
        gap: '1px',
        alignItems: 'center',
        color: '#fff !important',
        boxShadow: "rgba(0, 0, 0, 0.35) 0px -50px 36px -28px inset"
      },

      "& .colleague-finder": {
        width: '700px !important'
      },

      "& .active": {
        color: '#fff !important',
        background: '#EE602C !important',
        boxShadow: "rgb(50 50 93 / 25%) 0px 30px 60px -12px inset, rgb(0 0 0 / 30%) 0px 18px 36px -18px inset"
      }
    }
  },

  "& .menu-left": {
    background: '#EE602C',
    width: '200px',
    height: 'calc(100vh - 92px)',
    marginTop: '14px',
    float: 'left',
    borderTop: 'solid 1px #ccc',

    "& .tab-desktop": {
      cursor: 'pointer',

      "& .normal": {
        display: 'flex',
        justifyContent: 'flex-start',
        gap: '10px',
        padding: 10,
        color: '#fff !important',
      },

      "& .active": {
        color: '#fff !important',
        background: '#EE602C !important',
        boxShadow: "rgb(50 50 93 / 25%) 0px 30px 60px -12px inset, rgb(0 0 0 / 30%) 0px 18px 36px -18px inset"
      }
    }
  },

  "& .main-desktop": {
    float: 'left',
    padding: '10px',

    "& .tree": {
      width: '600px',
      height: 'calc(100vh - 170px)',
      overflow: 'auto'
    },

    "& .email, .last-location": {
      width: '50% !important'
    },

    "& .limit-text-2": {
      width: '100% !important'
    }
  },

  '@media only screen and (min-width: 800px)': {
    "& .setting": {
      "& .temperature-area": {
        "& button": {
          width: "120px"
        },
      }
    },

    "& .block-tab": {
      "& .tab": {
        marginLeft: '5px',
        marginRight: '5px',
        justifyContent: 'center',
        "& .normal": {
          width: '350px'
        }
      }
    },
  },

  '@media only screen and (max-width: 800px)': {
    '& .main': {
      width: '100%',
      margin: 'auto',
      padding: "5px 10px",
      // height: 'inherit',
      overflow: 'auto',
      height: 'calc(100vh - 210px)',

      '& .temperature-area': {
        overflow: 'auto',
        paddingBottom: '5px'
      },
    },

    '& span.MuiTypography-root': {
      marginRight: '12px'
    },
  },

}));


export const ColleagueFinderStyles = styled("div")(({ theme }) => ({
  height: 'calc(100% - 200px)',

  "& .search": {
    padding: "5px",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },

  "& .immerse-table-header": {
    display: 'none'
  },

  "& .location": {
    display: 'flex',
    fontSize: '.9rem',
    paddingLeft: '25px',
    gap: 12,
    marginBottom: 5,
    alignItems: 'center'
  },

  "& .location::before": {
    top: 'calc(var(--spacing) / -18)'
  },

  "& summary": {
    fontWeight: 'bold'
  },

  ".limit-text-1::-webkit-scrollbar, .limit-text-2::-webkit-scrollbar": {
    width: 0,
    height: 0
  },
  
  "& .limit-text-1": {
    overflowX: 'auto',
    width: 110,
    whiteSpace: 'nowrap',
    height: 'auto'
  },

  "& .limit-text-2": {
    overflowX: 'auto',
    width: 175,
    whiteSpace: 'nowrap'
  },

  '@media only screen and (max-width: 800px)': {
    "& .limit-text-1": {
      width: '300px !important',
    }
  },
}));